import React, {useState} from 'react';
import {useNavigate} from "react-router-dom";
import {useDispatch} from "react-redux";
import {setUser} from "../../redux/User";
import Cookies from 'js-cookie';

const ResetPassword = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [textMsg, setTextMsg] = useState('');

    const handleRegister = async () => {

        const response = await fetch(process.env.REACT_APP_API_URL + '/app/reset-password', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({email}),
        });

        setTextMsg("Your password has been reset. Please check your email for the new password.");

    };

    const handleLogin = () => {
        navigate("/login");
    }

    return (

        <>
            {textMsg == "" &&
                <div className="flex justify-center h-screen mt-6">
                    <div className="w-full max-w-md p-6">
                        <h2 className="text-2xl font-bold mb-6 text-center">Reset password</h2>
                        <div className="mb-4">
                            <label className="block text-gray-700 p-2 font-bold">Email</label>
                            <input
                                type="email"
                                value={email}
                                required={true}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Email"
                                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600"
                            />
                        </div>
                        <button
                            onClick={handleRegister}
                            className="font-bold w-full bg-second-bg text-white py-2 rounded-lg hover:bg-blue-700 transition duration-200"
                        >
                            Send new password
                        </button>
                    </div>
                </div>
            }

            {textMsg != "" &&
                <div className="flex justify-center h-screen mt-6">
                    <div className="w-full max-w-md p-6">
                        <h2 className="text-2xl font-bold mb-6 text-center">Reset password</h2>
                        <div className="mb-4">
                            <p className="text-center"> {textMsg}</p>
                            <button onClick={handleLogin}> Go to Login </button>
                        </div>
                    </div>
                </div>
            }
        </>

    );
};

export default ResetPassword;
